const ErrorNotFound = () => {
  return <div>404: Not Found!</div>;
};

export { ErrorNotFound };
